import gql from "graphql-tag";
/**  The interval of tick to query; Currently only Hourly is supported  */
export var Interval;
(function (Interval) {
    Interval["All"] = "All";
    Interval["Daily"] = "Daily";
    Interval["Hourly"] = "Hourly";
    Interval["Minute"] = "Minute";
    Interval["Monthly"] = "Monthly";
    Interval["Raw"] = "Raw";
})(Interval || (Interval = {}));
export var Outcome;
(function (Outcome) {
    Outcome["Cancelled"] = "Cancelled";
    Outcome["Executed"] = "Executed";
})(Outcome || (Outcome = {}));
/**  The unit to return an asset amount in; Natural chooses an opinionated 'best' option  */
export var Unit;
(function (Unit) {
    Unit["AssetA"] = "AssetA";
    Unit["AssetB"] = "AssetB";
    Unit["Lovelace"] = "Lovelace";
    Unit["Natural"] = "Natural";
    Unit["Usd"] = "USD";
})(Unit || (Unit = {}));
/**  The protocol version tag we're working with  */
export var Version;
(function (Version) {
    Version["V1"] = "V1";
    Version["V3"] = "V3";
})(Version || (Version = {}));
export const AssetMetadataFragmentDoc = gql `
  fragment AssetMetadata on Asset {
    id
    assetName
    ticker
    decimals
    logo
  }
`;
export const GetAssetsDocument = gql `
  query getAssets($ids: [ID!]!) {
    assets {
      byIds(ids: $ids) {
        ...AssetMetadata
      }
    }
  }
  ${AssetMetadataFragmentDoc}
`;
export const GetAssetDocument = gql `
  query getAsset($id: ID!) {
    assets {
      byId(id: $id) {
        ...AssetMetadata
      }
    }
  }
  ${AssetMetadataFragmentDoc}
`;
const defaultWrapper = (action, _operationName, _operationType, _variables) => action();
export function getSdk(client, withWrapper = defaultWrapper) {
    return {
        getAssets(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetAssetsDocument, variables, {
                ...requestHeaders,
                ...wrappedRequestHeaders,
            }), "getAssets", "query", variables);
        },
        getAsset(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetAssetDocument, variables, {
                ...requestHeaders,
                ...wrappedRequestHeaders,
            }), "getAsset", "query", variables);
        },
    };
}
//# sourceMappingURL=api.sdk.js.map